function getSessionIdFromCookieOrStorage() {
  const cookieMatch = /(?:^|; )session_id=([^;]*)/.exec(document.cookie);
  const cookieSessionId = cookieMatch?.[1] ? decodeURIComponent(cookieMatch[1]).trim() : '';

  if (cookieSessionId && cookieSessionId !== 'undefined' && cookieSessionId !== 'null') {
    return cookieSessionId;
  }

  const storageSessionId = localStorage.getItem('session_id');
  if (storageSessionId && storageSessionId !== 'undefined' && storageSessionId !== 'null') {
    return storageSessionId;
  }

  return null;
}

/**
 * Get Comments
 * @param {any} projectId
 * @param {any} patientId
 * @param {any} viewer
 */
export async function getComments(projectId, patientId, viewer) {
  const API_URL = `${process.env.API_URL}/comments/viewer/${projectId}/${patientId}/${viewer}`;

  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const session_id = getSessionIdFromCookieOrStorage();
  if (session_id) {
    headers.append('x-api-key', session_id);
  }

  const response = await fetch(API_URL, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

  if (response.status === 401) {
    return { error: 'UNAUTHORIZED' };
  }

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
}

/**
 * Add Comment
 * @param {any} projectId
 * @param {any} patientId
 * @param {any} viewer
 * @param {any} payload
 */
export async function addComment(projectId, patientId, viewer, payload) {
  const API_URL = `${process.env.API_URL}/comments/viewer/${projectId}/${patientId}/${viewer}`;

  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const session_id = getSessionIdFromCookieOrStorage();
  if (session_id) {
    headers.append('x-api-key', session_id);
  }

  const response = await fetch(API_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
    credentials: 'include',
  });

  if (response.status === 401) {
    return { error: 'UNAUTHORIZED' };
  }

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
}

/**
 * Delete Comment
 * @param {any} projectId
 * @param {any} patientId
 * @param {any} viewer
 * @param {any} commentId
 */
export async function deleteComment(projectId, patientId, viewer, commentId) {
  const API_URL = `${process.env.API_URL}/comments/viewer/${projectId}/${patientId}/${viewer}/${commentId}`;

  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const session_id = getSessionIdFromCookieOrStorage();
  if (session_id) {
    headers.append('x-api-key', session_id);
  }

  const response = await fetch(API_URL, {
    method: 'DELETE',
    headers,
    credentials: 'include',
  });

  if (response.status === 401) {
    return { error: 'UNAUTHORIZED' };
  }

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
}
